import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-2xs font-medium ring-1 ring-inset",
  {
    variants: {
      tone: {
        neutral: "bg-muted/60 text-foreground/80 ring-border",
        muted: "bg-transparent text-muted-foreground ring-border",
        success: "bg-success/15 text-success ring-success/30",
        warning: "bg-warning/15 text-warning ring-warning/30",
        danger: "bg-destructive/15 text-destructive ring-destructive/30",
        brand: "bg-brand/15 text-brand ring-brand/30",
        info: "bg-blue-500/10 text-blue-300 ring-blue-500/30",
      },
    },
    defaultVariants: { tone: "neutral" },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, tone, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ tone }), className)} {...props} />;
}
